import { Component, inject, Input } from '@angular/core';
import { LoaderService } from 'src/app/services/loader.service';
import { SpacerComponent } from 'src/app/ui/atoms/spacer/spacer.component';
import { NgOptimizedImage } from '@angular/common';

@Component({
    selector: 'app-loader',
    imports: [
        SpacerComponent,
        NgOptimizedImage,
    ],
    templateUrl: './loader.component.html',
    styleUrl: './loader.component.scss'
})
export class LoaderComponent {
  private loaderService = inject(LoaderService);
  isLoading = this.loaderService.isLoading;

  @Input() text: string;
}
